"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // styles
    showLabel: true,
    styleObject: {
        display: 'block',
    },
};
